import type * as React from 'react'
import { Switch } from './switch.js'

export interface ToggleFieldProps {
  label: string
  description: string
  checked: boolean
  onChange: (checked: boolean) => void
  children?: React.ReactNode
}

export function ToggleField({ label, description, checked, onChange, children }: ToggleFieldProps) {
  return (
    <div
      className={`rounded-xl border transition-colors ${
        checked
          ? 'border-[#f97316]/50 bg-[#f97316]/10'
          : 'border-border bg-input/50 hover:border-hover hover:bg-input/80'
      }`}
    >
      <button
        type="button"
        className="flex items-center justify-between p-4 cursor-pointer w-full text-left"
        onClick={() => onChange(!checked)}
      >
        <div>
          <p className="font-medium text-white">{label}</p>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
        <Switch checked={checked} onCheckedChange={onChange} className={checked ? '' : ''} />
      </button>
      {children && <div className="px-4 pb-4 pt-0">{children}</div>}
    </div>
  )
}
